import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="October 15, 2026" testId="privacy-page">
      <LegalSection title="Who we are">
        <p>Ryan (the website at ryanremembers.com and the Ryan Chrome extension) is operated by <strong>MERA Technology</strong> ("we", "us"). This policy explains what we collect, why, and the choices you have.</p>
      </LegalSection>

      <LegalSection title="What we collect">
        <ul>
          <li><strong>Account information:</strong> your name, email address and profile picture from Google when you sign in.</li>
          <li><strong>Content you choose to save:</strong> the AI conversation messages you pin, your notes, tags, volumes, the page URL and title, and any images you upload. The extension only reads a message when you click Pin; it does not record your conversations in the background.</li>
          <li><strong>Billing information:</strong> your subscription plan and status. Card details are handled by Stripe and never stored on our servers.</li>
          <li><strong>Usage information:</strong> product events such as installing the extension, completing onboarding steps, the number of items saved, Ask Ryan questions used, and upgrade clicks. We use this to improve the product.</li>
          <li><strong>Extension storage:</strong> the extension stores a sign-in token and basic settings in Chrome's local storage on your device.</li>
        </ul>
      </LegalSection>

      <LegalSection title="How we use it">
        <ul>
          <li>To provide the service: save, organize, search, share and export your content.</li>
          <li>To answer Ask Ryan questions and read text from uploaded images, using your saved content.</li>
          <li>To send emails you've opted into, such as reading digests, and service notices.</li>
          <li>To process payments and manage subscriptions.</li>
          <li>To understand how the product is used and improve it.</li>
        </ul>
        <p>We do not sell your personal information, and we do not use your saved content to advertise to you.</p>
      </LegalSection>

      <LegalSection title="Service providers">
        <p>We share data only with providers that help us run Ryan, and only as needed:</p>
        <ul>
          <li><strong>Google</strong> for sign-in.</li>
          <li><strong>Stripe</strong> for payments.</li>
          <li><strong>Resend</strong> for sending email.</li>
          <li><strong>Anthropic</strong> (Claude) for Ask Ryan answers and image text recognition. Relevant saved content is sent to process your request.</li>
          <li><strong>Cloud hosting and storage providers</strong> to host the app, the database and uploaded files.</li>
          <li><strong>Notion</strong>, only if you connect your Notion account to sync saves.</li>
        </ul>
      </LegalSection>

      <LegalSection title="Sharing and teams">
        <p>Content is private by default. If you create a share link, anyone with the link can view that volume or library until you turn the link off. If you're in a Synthesis team workspace, shared volumes are visible to your team members, and the team owner can see the member list and pooled Ask Ryan usage.</p>
      </LegalSection>

      <LegalSection title="Chrome extension">
        <p>The extension runs only on claude.ai, chatgpt.com, chat.openai.com and gemini.google.com to add the Pin button. Its use of information received from Chrome APIs follows the Chrome Web Store User Data Policy, including the Limited Use requirements. Data is used only to provide Ryan's single purpose: saving and organizing moments from AI conversations.</p>
      </LegalSection>

      <LegalSection title="Retention and deletion">
        <p>We keep your data while your account is active. You can delete individual saves at any time and export your data as JSON or Markdown. To delete your account and all associated data, email us and we'll do it within 30 days.</p>
      </LegalSection>

      <LegalSection title="Security">
        <p>Data is sent over HTTPS, and access to our systems is restricted. No method of storage is perfectly secure, but we take reasonable steps to protect your information.</p>
      </LegalSection>

      <LegalSection title="Your rights">
        <p>Depending on where you live, you may have the right to access, correct, delete or export your personal data, or to object to certain processing. Email us to make a request. Ryan is not directed to children under 13, and we don't knowingly collect their data.</p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>If we make material changes to this policy, we'll update the date above and notify you by email or in the app.</p>
      </LegalSection>
    </LegalLayout>
  );
}
